// extracted by mini-css-extract-plugin
module.exports = {"winnerItem":"_e734729","reversed":"_2d38043","details":"_f89b481","username":"_fb3b1ce","award":"_7f66129"};